<div #mapElement id="azure-map"></div>
